import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { IBannerData, ISurgicalData } from "../../exports/interfaces";
import {
  fetchFacialPlasticSurgeons,
  fetchFacialPlasticSurgeonsBanner,
} from "../../api/SurgicalDomainApi";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";

const FacialPlasticSurgeons = () => {
  const { setLoading } = useLoader();
  const [facialPlasticSurgeonsBanner, setfacialPlasticSurgeonsBanner] =
    useState<IBannerData[]>([]);
  const [facialPlasticSurgeonsData, setFacialPlasticSurgeonsData] = useState<
    ISurgicalData[]
  >([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([
      fetchFacialPlasticSurgeonsBanner(),
      fetchFacialPlasticSurgeons(),
    ])
      .then(([facialPlasticSurgeonsBannerData, facialPlasticSurgeonsData]) => {
        setfacialPlasticSurgeonsBanner(facialPlasticSurgeonsBannerData);
        setFacialPlasticSurgeonsData(facialPlasticSurgeonsData);
        // setArchiveVideoData(videoData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner bannerData={facialPlasticSurgeonsBanner} page={'Who is a Facial Plastic Surgeon'} /> 
      <SurgicalDomainsDescription
        descriptionData={facialPlasticSurgeonsData}
      />
    </>
  );
};

export default FacialPlasticSurgeons;
